import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Signal } from '@angular/core';
import { DashboardListItem } from '../../features/dashboard/models/dashboard-list-item/dashboard-list-item.model';

export function uniqueDashboardNameValidator(
  getDashboards: Signal<DashboardListItem[]>,
  currentId?: string, // allow editing existing dashboard
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').trim().toLowerCase();
    if (!value) return { emptyName: true };

    const exists = getDashboards().some((d) => {
      return d.name.toLowerCase() === value && d.id !== currentId;
    });

    return exists ? { duplicateName: true } : null;
  };
}
